import { render, staticRenderFns } from "./CallButton.vue?vue&type=template&id=ed6613a2&scoped=true&"
import script from "./CallButton.vue?vue&type=script&lang=js&"
export * from "./CallButton.vue?vue&type=script&lang=js&"
import style0 from "./CallButton.vue?vue&type=style&index=0&id=ed6613a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed6613a2",
  null
  
)

export default component.exports